import { FC, SVGProps } from 'react'

export const ChevronLeft: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M16.4983 2.43945C16.8079 2.71464 16.8357 3.18869 16.5606 3.49828L9.00347 12L16.5606 20.5017C16.8357 20.8113 16.8079 21.2854 16.4983 21.5606C16.1887 21.8358 15.7146 21.8079 15.4394 21.4983L7.43944 12.4983C7.18685 12.2141 7.18685 11.7859 7.43944 11.5017L15.4394 2.50174C15.7146 2.19215 16.1887 2.16426 16.4983 2.43945Z"
			fill="currentColor"
		/>
	</svg>
)
